<template>
  <div>
    <b-card v-show="shownewpage" class="">
      <div>
        <div class="mb-4">
          <base-button
            icon
            type=""
            class="custpad5-10 bg-f4f5f6"
            v-if="shownewpage"
            @click="shownewpage = false"
          >
            <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>

            <span class="btn-inner--text">Back</span>
          </base-button>
        </div>
        <AddCourseCat v-if="shownewpage" :toggleEditModal="toggleEditModal" />
      </div>
    </b-card>
    <b-card v-if="!shownewpage" class="cust-border-0 border-none">
      <!-- <modal :show.sync="editModal" header-classes="bg-primary p-3">
    <b-modal id="edit-modal" okTitle="Save" centered hide-header>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Course Name</p>
        <base-input
          placeholder="Enter Course Name"
          class="cust-mb0"
        ></base-input>
      </div>
      <div class="">
        <p class="font-semibold text-md pb-1">Course Icon</p>
        <div class="flex">
          <div class="flex px-5 py-1 bg-f4f5f6 rounded-full">
            <p class="text-xs font-semibold ">UploadedIcon.jpg</p>
            <feather-icon
              icon="XIcon"
              class=" font-semibold cursor-pointer icon18px ml-5 my-auto"
            ></feather-icon>
          </div>
        </div>
      </div>
    </b-modal>
    <b-card v-if="!shownewpage" class="cust-border-0 border-none">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6> -->
      <AddPageDetail
        :data="selectedCagegory"
        :editModal="editModal"
        :toggleEditModal="toggleEditModal"
      />
      <!-- <template slot="footer">
          <base-button @click="saveChanges(name)" type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template> -->
      <!-- </modal> -->
      <!-- <AddPageDataSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    /> -->

      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Course Categories</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <base-button
          outline
          type="primary"
          class="flex px-6 py-1 mx-1"
          @click="shownewpage = true"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
          Categories
        </base-button>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
          v-model="search"
          @keyup="searchData()"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="categories"
        border
      >
        <el-table-column type="index" label="Sr no." width="80px" sortable>
        </el-table-column>
        <el-table-column
          label="Category"
          min-width="140px"
          prop="category"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="No of Courses "
          min-width="120px"
          prop="subtitle"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black">{{ row.courses.length }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Description"
          min-width="200px"
          prop="description"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black" v-html="row.description"></span>
          </template>
        </el-table-column>

        <el-table-column label="Icon" min-width="130px" prop="iconimg" sortable>
          <template v-slot="{ row }">
            <img
              class="rounded-full w-8 h-8"
              :src="$imageURL + '/' + row.image"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Edited By"
          min-width="130px"
          prop="editedby"
          sortable
        >
          <template v-slot="{ row }">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="row.isEdited"
            >
              {{
                row.editedBy.at(-1)._user.firstname +
                  " " +
                  row.editedBy.at(-1)._user.lastname || " "
              }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="Action" min-width="">
          <template v-slot="{ row }">
            <div class="flex items-center">
              <div class="flex items-center mr-4 cursor-pointer">
                <feather-icon
                  @click="editCategory(row)"
                  block
                  icon="Edit3Icon"
                  svgClasses="w-5"
                ></feather-icon>
              </div>
              <div class="flex items-center cursor-pointer">
                <feather-icon
                  @click="deleteCategory(row._id)"
                  icon="Trash2Icon"
                  svgClasses="w-5"
                ></feather-icon>
              </div>
            </div>
            <!-- <div class="flex items-center">
              <div class="flex items-center mr-4 cursor-pointer">
                <feather-icon
                  v-b-modal="'edit-modal'"
                  block
                  icon="Edit3Icon"
                  svgClasses="w-5"
                ></feather-icon>
              </div>
            </div> -->
            <!-- <div class="flex items-center cursor-pointer">
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5"
                @click="deletePopup"
              ></feather-icon>
            </div> -->
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import Data from "./components/Data";
import AddPageDetail from "./components/AddPageDetail";
import AddPageDataSidebar from "./components/AddPageDataSidebar.vue";
import AddCourseCat from "./components/AddCourseCat";
import _ from "lodash";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    AddPageDetail,
    AddPageDataSidebar,
    AddCourseCat,
  },
  data() {
    return {
      Data,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      shownewpage: false,
      // categories:"",
      search: "",
      selectedCagegory: {},
      categories: "",
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    async getCategories() {
      if (this.search == "") {
        const { data } = await this.$store.dispatch("eLearning/getCategories");
        this.categories = data;
      } else {
        const { data } = await this.$store.dispatch("eLearning/getCategories", {
          searchCat: this.search,
        });
        // console.log(data);
        this.categories = data;
      }
    },
    async searchData() {
      await this.getCategories();
    },
    async editCategory(data) {
      //  this.name=categories.name
      this.editModal = true;
      this.selectedCagegory = data;

      this.$store.commit("eLearning/selectedCategoryForEdit", data);
      // console.log(data);
      // console.log(this.selectedCategoryForEdit);
      // this.getCategories();
    },
    async toggleEditModal() {
      this.editModal = false;
      this.shownewpage = false;
      await this.getCategories();
    },
    // async deleteCategory(_id) {
    //   const { data } = await this.$store.dispatch(
    //     "eLearning/deleteCategories",
    //     { _id }

    //   );

    //   console.log(_id);
    //   this.getCategories();
    // },
    deleteCategory(_id) {
      this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          // this.$swal("Deleted!", "Your file has been deleted.", "success");
          this.$swal.fire({
            title: "Deleted",
            text: "File deleted for this course",
            icon: "success",
            confirmButtonColor: "#830c81",
          });
          const { data } = this.$store.dispatch("eLearning/deleteCategories", {
            _id,
          });
          this.getCategories();
          this.getCategories();
        }
      });
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
